export const chatMessageFragment = `
  fragment ChatMessageFragment on ChatMessage {
    id
    companyId
    createdAt

    chatId

    text
    isSystem

    senderType
    senderId

    senderAccount {
      login
    }

    sentAt

    attachments {
      id
      name
      url
      countBefore
      countAfter
    }

    replyTo
    replyToMessage {
      id
      text
      senderType
      senderId
      sentAt
      attachments {
        name
        url
      }

      senderAccount {
        login
      }
      senderPerson {
        name
      }
    }

    needEdit
    needDelete

    error
  }
`;
